

import React, { useEffect, useRef, useState } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from '@mui/icons-material/Clear';
import { Delete, LocationOn } from '@mui/icons-material';
import { useMutation, useQuery } from 'react-query';
import { enqueueSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { GetLocation, PostLocation } from '../../Services/Location';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { setSnackbar } from '../../Redux/Actions/SnackBar';

const LocationModal = () => {
    const [open, setOpen] = useState(false);
    const [input, setInput] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [error, setError] = useState(null);
    const [latLong, setLatLong] = useState({ lat: "", long: "" });


    const autocompleteService = useRef(null);
    const geocoder = useRef(null);

    const token = localStorage.getItem("bhaarattoken");

    const dispatch = useDispatch();

    const { data, refetch, isFetching, isLoading } = useQuery(
        ["location-data"],
        () => GetLocation(),
        { enabled: Boolean(token) }
    );

    const LocationData = data?.data?.data?.address;

    useEffect(() => {
        if (!window.google) return;
        if (!autocompleteService.current) {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
        }
        if (!geocoder.current) {
            geocoder.current = new window.google.maps.Geocoder();
        }
    }, []);

    useEffect(() => {
        if (LocationData) setCurrentAddress(LocationData);
    }, [LocationData]);

    // useEffect(() => {
    //     if (!LocationData || !localStorage.getItem("address")) {
    //         setOpen(true);
    //     }
    // }, [LocationData]);


    useEffect(() => {
        const addressFromStorage = localStorage.getItem("address");
        const addressFromAPI = data?.data?.data?.address;

        if (!isLoading && !isFetching && !addressFromAPI && !addressFromStorage) {
            setOpen(true);
        }
    }, [isLoading, isFetching, data]);


    const handleInput = (e) => {
        const value = e.target.value;
        setInput(value);
        if (!value || !autocompleteService.current) {
            setSuggestions([]);
            return;
        }
        autocompleteService.current.getPlacePredictions(
            { input: value },
            (predictions, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    setSuggestions(predictions);
                } else {
                    setSuggestions([]);
                }
            }
        );
    };

    const handleSelect = (suggestion) => {
        const address = suggestion.description;
        setInput(address);
        setSuggestions([]);
        setSelectedAddress(address);
        setCurrentAddress("");

        geocoder.current.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const loc = results[0].geometry.location;
                setLatLong({ lat: loc.lat(), long: loc.lng() });
            }
        });
    };

    const detectCurrentLocation = () => {
        if (!navigator.geolocation) {
            setError('Geolocation not supported');
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async ({ coords: { latitude, longitude } }) => {
                try {
                    const res = await fetch(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAO3TRgzZx5X3i6tTcuNMjCvvCxhWe4M3g`
                    );
                    const data = await res.json();
                    if (data.results.length > 0) {
                        const addr = data.results[0].formatted_address;
                        setCurrentAddress(addr);
                        setSelectedAddress("");
                        setLatLong({ lat: latitude, long: longitude });
                    } else {
                        setError('No address found');
                    }
                } catch (err) {
                    setError('Failed to fetch address');
                }
            },
            (err) => setError(err.message)
        );
    };

    const { mutate: AddLocation } = useMutation(PostLocation, {
        onSuccess: (res) => {
            if (res?.data?.response_code === 200) {
                dispatch(
                    setSnackbar({
                        open: true,
                        message: res.data.msg,
                        variant: "success",
                    })
                );
                setSelectedAddress("");
                setCurrentAddress(res?.data?.data?.address || "");
                localStorage.removeItem("address");
                setOpen(false);
                refetch();
            } else {
                enqueueSnackbar(res?.data?.msg, { variant: "error" });
            }
        }
    });

    const handleSetLocalStorage = (value) => {
        localStorage.setItem("address", value);
        setOpen(false);
    };

    return (
        <>
            {(LocationData || localStorage.getItem("address")) ? <div onClick={() => setOpen(true)} className="flex justify-between border-b-2 border-white w-32 cursor-pointer  text-white  truncate">
                {/* <img src={LocationImage} className="h-5" alt="location-icon" /> */}



                <div className="text-sm leading-tight max-w-xs">
                    <div className="font-semibold text-black">
                        Delivery in <span className="text-pink-500">10 Mins</span>
                    </div>
                    <div className="text-gray-700 truncate flex items-center">
                        {LocationData || localStorage.getItem("address")}
                        <KeyboardArrowDownIcon className="w-4 h-4 ml-1" />
                    </div>
                </div>
            </div> : <div onClick={() => setOpen(true)} className="flex justify-between border-b-2 border-white w-32 cursor-pointer">
                {/* <img src={LocationImage} className="h-5" alt="location-icon" /> */}
                <LocationOn />
                <p className=" text-opacity-50">Location</p>
                <ArrowDropDownIcon className="" />
            </div>}
            {open && (
                <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-60 z-50 px-4">
                    <div className="bg-white rounded-2xl relative w-full max-w-lg p-6 shadow-2xl">
                        {(LocationData || localStorage.getItem("address")) && (
                            <button
                                onClick={() => setOpen(false)}
                                className="absolute right-4 top-4 p-1 rounded-full hover:bg-gray-200 transition"
                            >
                                <ClearIcon />
                            </button>
                        )}

                        <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
                            Set Your Location
                        </h2>

                        {/* Input + Clear */}
                        <div className="relative w-full mb-3">
                            <input
                                value={input}
                                type="search"
                                onChange={handleInput}
                                placeholder="Search for a location..."
                                className="w-full p-3 pr-10 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
                            />
                            {input && (
                                <button
                                    onClick={() => setInput("")}
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                                >
                                    <ClearIcon fontSize="small" />
                                </button>
                            )}
                        </div>

                        {/* Suggestions */}
                        {suggestions.length > 0 && (
                            <ul className="border border-gray-200 rounded-lg mb-4 max-h-48 overflow-y-auto shadow-sm divide-y">
                                {suggestions.map((sug, idx) => (
                                    <li
                                        key={idx}
                                        onClick={() => handleSelect(sug)}
                                        className="px-4 py-3 hover:bg-gray-50 cursor-pointer text-sm text-gray-700"
                                    >
                                        {sug.description}
                                    </li>
                                ))}
                            </ul>
                        )}

                        {/* Current Location */}
                        <div className="flex items-start justify-between border-t pt-4 mt-4">
                            <div>
                                <p className="text-sm font-semibold text-gray-700">📍 Use Current Location</p>
                                <p className="text-xs text-gray-500">
                                    Enable to detect your current address automatically
                                </p>
                            </div>
                            <button
                                onClick={detectCurrentLocation}
                                className="bg-pink-500 hover:bg-pink-600 text-white text-sm px-4 py-2 rounded-md transition"
                            >
                                Enable
                            </button>
                        </div>

                        {/* Selected Address */}
                        {selectedAddress && (
                            <div className="mt-4 text-sm text-gray-700">
                                <p className="font-semibold mb-1">Selected Address:</p>
                                <p className="text-gray-600">{selectedAddress}</p>
                            </div>
                        )}

                        {/* Saved Address */}
                        {(currentAddress || localStorage.getItem("address")) && (
                            <div className="mt-4 text-sm text-gray-700">
                                <div className="flex justify-between items-center">
                                    <p className="font-semibold mb-1">Saved Location</p>
                                    {(LocationData || localStorage.getItem("address")) && (
                                        <button
                                            onClick={() => {
                                                if (token) {
                                                    AddLocation({ address: "All" }); // Clears server-side
                                                } else {
                                                    localStorage.removeItem("address");
                                                }
                                                setOpen(false);
                                                setCurrentAddress("");
                                            }}
                                            className="text-red-500 hover:text-red-600"
                                        >
                                            <Delete color="error" />
                                        </button>
                                    )}
                                </div>
                                <p className="text-gray-600">
                                    🏠 {currentAddress || localStorage.getItem("address")}
                                </p>
                            </div>
                        )}

                        {/* Error */}
                        {error && <p className="text-red-500 mt-3 text-sm text-center">{error}</p>}

                        {/* Confirm Button */}
                        {(currentAddress || selectedAddress) && (
                            <div className="mt-6 flex justify-center">
                                <button
                                    onClick={() => {
                                        const address = currentAddress || selectedAddress;
                                        if (token) {
                                            AddLocation({
                                                address,
                                                longitude: latLong.long,
                                                latitude: latLong.lat,
                                            });
                                        } else {
                                            handleSetLocalStorage(address);
                                        }
                                    }}
                                    className="w-full bg-pink-500 hover:bg-pink-600 text-white text-sm font-semibold py-3 rounded-lg transition"
                                >
                                    Confirm and Continue
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default LocationModal;


